import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("realtify_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      // Never hijack failed login attempts — the caller shows a toast on /partner or /login.
      const url = (err.config && err.config.url) || "";
      const isLoginAttempt = url.includes("/auth/login") || url.includes("/auth/signup");

      // Public pages should never be force-navigated to /login.
      const publicPaths = ["/", "/services", "/reviews", "/about", "/contact", "/partner", "/login", "/signup"];
      const path = window.location.pathname;
      const onPublic = publicPaths.includes(path);

      if (!isLoginAttempt && !onPublic) {
        localStorage.removeItem("realtify_token");
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  },
);

export const money = (n) => {
  const v = Number(n || 0);
  return v.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  });
};

export const pct = (n) => `${Math.round(Number(n || 0))}%`;
